var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import classNames from 'classnames';
import get from 'lodash/get';
import Input from './Input';
export default class MaxLength extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            visible: false,
            curLength: 0,
        };
        this.handleChange = (e) => {
            const { value } = e.target;
            const { maxLength = 10, tipLength = 5, onChange } = this.props;
            const { visible } = this.state;
            const curLength = value.length;
            const curVisible = value.length >= maxLength - tipLength;
            if (curVisible || visible !== curVisible) {
                this.setState({
                    curLength,
                    visible: curVisible,
                });
            }
            if (onChange) {
                onChange(e);
            }
        };
    }
    getAddonAfter() {
        const { visible } = this.state;
        const { inputPrefixCls, maxLength } = this.props;
        const inputLength = get(this, 'input.input.value', '').length;
        const addonAfterclassName = visible
            ? classNames(`${inputPrefixCls}-addon-show`, {
                [`${inputPrefixCls}-addon-show-full`]: inputLength === maxLength,
            })
            : `${inputPrefixCls}-addon-hidden`;
        return {
            count: `${inputLength}/${maxLength}`,
            addonAfterclassName,
        };
    }
    render() {
        const _a = this.props, { className, prefixCls, inputPrefixCls, size, suffix } = _a, restProps = __rest(_a, ["className", "prefixCls", "inputPrefixCls", "size", "suffix"]);
        const { count, addonAfterclassName } = this.getAddonAfter();
        const inputClassName = classNames(prefixCls, className, {
            [`${prefixCls}-${size}`]: !!size,
        });
        return (<Input {...restProps} onChange={this.handleChange} size={size} className={inputClassName} prefixCls={inputPrefixCls} addonAfter={count} addonAfterClassName={addonAfterclassName}/>);
    }
}
MaxLength.defaultProps = {
    inputPrefixCls: 'sup-input',
    prefixCls: 'sup-input-maxLength',
    tipLength: 5,
    maxLength: 10,
};
